export class UnifiedTableRecord {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "schemaName",
            "baseName": "schemaName",
            "type": "string",
            "format": ""
        },
        {
            "name": "dbName",
            "baseName": "dbName",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowCount",
            "baseName": "rowCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "snapshotCount",
            "baseName": "snapshotCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<ColumnMetadata>",
            "format": ""
        },
        {
            "name": "serverId",
            "baseName": "serverId",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineType",
            "baseName": "engineType",
            "type": "string",
            "format": ""
        },
        {
            "name": "recordType",
            "baseName": "record_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "resource",
            "baseName": "resource",
            "type": "DBResourceMetadata",
            "format": ""
        },
        {
            "name": "snapshot",
            "baseName": "snapshot",
            "type": "DBSnapshotMetadata",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedTableRecord.attributeTypeMap;
    }
    constructor() {
    }
}
